<template>
  <div class="my-coaching-menu">
    <ul>
      <li @click="moveMenu('/my_coaching')" style="width: 23%">
        <p :class="{ active: $router.currentRoute.name == 'my_coaching' }">오늘 일정</p>
      </li>
      <li @click="moveMenu('/next_coaching')" style="width: 23%">
        <p :class="{ active: $router.currentRoute.name == 'next_coaching' }">다음 일정</p>
      </li>
      <li @click="moveMenu('/coaching_request')" style="width: 26%">
        <p :class="{ active: $router.currentRoute.name == 'coaching_request' }">
          코칭 요청 <span>{{ requestCount }}</span>
        </p>
      </li>
      <li @click="moveMenu('/coaching_message')">
        <p :class="{ active: $router.currentRoute.name == 'coaching_message' }">
          메세지 <span>{{ unreadCount }}</span>
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "inc_menu",
  props: {},
  watch: {},
  data: () => ({
    unreadCount: 0,
    totalReceivedCount: 0,
    requestCount: 0,
  }),
  mounted() {
    this.getMessageCount();
    this.getRequestCount();
  },
  methods: {
    getRequestCount() {
      let params = {
        coarIdx: this.$store.state.userInfo.idxTbCoarch,
      };
      this.axios
        .get("/front/coarching/reservation/count", { params })
        .then((res) => {
          if (res.data.success) {
            this.requestCount = res.data.contentinfo.cnt;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMessageCount() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/chat/count", { params })
        .then((res) => {
          if (res.data.success) {
            let tempCount = res.data.contentinfo;
            this.unreadCount = parseInt(tempCount.qnaUnreadCount) + parseInt(tempCount.unreadCount);
            if (this.unreadCount >= 100) {
              this.unreadCount = "99+";
            }
            this.totalReceivedCount = res.data.contentinfo.totalReceivedCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    moveMenu(uri) {
      this.$router.push(uri);
      // location.href=uri;
    },
  },
};
</script>
